import { render, staticRenderFns } from "./DialogHistory.vue?vue&type=template&id=6b74570e&scoped=true&"
import script from "./DialogHistory.vue?vue&type=script&lang=js&"
export * from "./DialogHistory.vue?vue&type=script&lang=js&"
import style0 from "./DialogHistory.vue?vue&type=style&index=0&id=6b74570e&prod&lang=less&"
import style1 from "./DialogHistory.vue?vue&type=style&index=1&id=6b74570e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74570e",
  null
  
)

export default component.exports